import { Splide, SplideSlide } from '@splidejs/react-splide';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
// Splide's core stylesheet (track/slides/arrows/pagination). Imported here so
// the gallery is self-sufficient wherever it's used — previously it relied on
// the core CSS being pulled in incidentally by other components on the page,
// which broke the gallery when SplideGallery rendered on a page (e.g. the
// HotelSearchModule) that loads none of those components.
import '@splidejs/react-splide/css';
import './splideGallery.less';
import getImagePathFromName from '@skygroup/shared/utils/getImagePathFromName';

interface Props {
  images: string[];
  isDynamicPackageSearch?: boolean;
  arrows?: boolean;
}

const SplideGallery = ({ images, isDynamicPackageSearch, arrows = false }: Props) => {
  const { siteConfig } = useSelector((data: RootState) => data.config.config);

  // TODO CHANGE TO NEW SPLIDE GALLERY WHEN MOVED ON HOVER
  return (
    <Splide
      options={{
        autoWidth: true,
        pagination: true,
        arrows: arrows,
        direction: siteConfig.direction,
        rewind: true,
      }}
      className={`splide-gallery ${isDynamicPackageSearch ? 'dynamic-package' : ''}`}
    >
      {images?.length > 0 ?
          images.map((item, i) => (
        <SplideSlide key={i}>
          <img src={getImagePathFromName(item)} className="img" />
        </SplideSlide>
      )) :
          <SplideSlide key={1}>
              <img src={'/assets/images/hotel-default.png'} className="img" />
          </SplideSlide>
      }
    </Splide>
  );
};

export default SplideGallery;